<div class="card-image-simple">
    <!-- Image Section -->
    <div class="card-image-simple-image">
      <img [src]="cardInfo.imageUrl" alt="Quiero comenzar mi aventura" class="img-fluid">
      <div class="image-overlay">
        <p class="badge">{{cardInfo.badgeText}}</p>
        <h3 class="overlay-title">{{cardInfo.title}}</h3>
      </div>
    </div>
</div>
  